import { Paginatable } from "../common/Paginatable.dto";
import { UserEssential } from "../sso/User.dto";

export enum FileExportHistoryOutputFormat {
  Zip = "ZIP",
  Excel = "EXCEL",
  Csv = "CSV",
  Pdf = "PDF",
}

export enum FileExportHistoryType {
  Econsent = "ECONSENT",
  SubjectList = "SUBJECT_LIST",
  DocumentSignMerge = "DOCUMENT_SIGN_MERGE",
}

export enum FileExportHistoryStatus {
  Requested = "REQUESTED",
  Generating = "GENERATING",
  Done = "DONE",
  Failed = "FAILED",
}

export interface FileExportHistory {
  id: bigint;
  folderId: bigint;
  outputFormat: FileExportHistoryOutputFormat;
  type: FileExportHistoryType;
  bucket: string | null;
  key: string | null;
  payload: string | null;
  status: FileExportHistoryStatus;
  requestedAt: Date;
  generatedAt: Date | null;
  expiryAt: Date | null;
  actantId: bigint;
}

export type FileExportHistorySummary = Omit<FileExportHistory, "actantId"> & { actant: UserEssential | null };

export interface PaginateFileExportHistoriesRequest {
  folderId: bigint;
  page: number;
  rpp: number;
}

export type PaginateFileExportHistoriesResponse = Paginatable<FileExportHistorySummary>;

export interface CreateFileExportHistoryRequest {
  folderId: bigint;
  outputFormat: FileExportHistoryOutputFormat;
  type: FileExportHistoryType;
  timezoneOffset?: number;
  includeDeletedResource?: boolean;
}

export type CreateFileExportHistoryResponse = FileExportHistory | null;

export interface DownloadFileExportHistoryRequest {
  folderId: bigint;
  fileExportHistoryId: bigint;
}

export type DownloadFileExportHistoryResponse = { url: string };
